export default class BackgroundChanger {
  constructor() {
    this.outerElement = document.querySelector('.js-background-changer')
    if (!this.outerElement) { return }

    this.list = this.outerElement.querySelector('.js-background-changer-list')
    this.item = this.list.children
    this._init()
  }

  _init() {
    // this.item.forEach(item => {
    //   console.log(item)
    // })
    ;[].forEach.call(this.item, item => {
      let target = item.getAttribute('data-hover');

      item.addEventListener('mouseenter', () => {
        this.outerElement.classList.add('is-hover')
        this.outerElement.classList.add('visible-'.concat(target))
      })

      item.addEventListener('mouseleave', () => {
        this.outerElement.classList.remove('is-hover')
        this.outerElement.classList.remove('visible-'.concat(target))
      })
    })
  }
}
